import { Component, OnInit, OnDestroy } from '@angular/core';
import { SsInventoryService } from 'shared/services/SS-Inventory/ss-inventory.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DataSharingService } from 'shared/services/data-sharing/data-sharing.service';
import { UserService } from 'shared/services/User/user.service';
import { VendorsService } from 'shared/services/SS-vendors/vendors.service';
import * as _ from 'lodash';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SsOnboardingService } from 'shared/services/SS-Onboard/ss-onboarding.service';
import { AppComponent } from 'app/app.component';
import { AlertPopupService } from 'shared/services/SS-Alert/alert-popup.service';
import { environment } from 'environments/environment';



@Component({
  selector: 'app-connect-team-account',
  templateUrl: './connect-team-account.component.html',
  styleUrls: ['./connect-team-account.component.css']
})
export class ConnectTeamAccountComponent implements OnInit, OnDestroy {
  loading: boolean;
  team: any;
  eventName: string;
  connectForm: FormGroup;
  imageURL: string = environment.URL_TEAM_IMAGES;

  constructor(
    private inventoryService: SsInventoryService,
    private router: Router,
    private app: AppComponent,
    private data: DataSharingService,
    private userService: UserService,
    private alertService: AlertPopupService,
    private onboardingService: SsOnboardingService,
    private vendorService: VendorsService,
    private route: ActivatedRoute
  ) { this.route.queryParams.subscribe(params => { this.eventName = params.eventName; }); }

  ngOnInit() {
    document.body.style.backgroundColor = 'lightgray';
    this.data.changeTitle('CONNECT TEAM ACCOUNT');
    this.connectForm = new FormGroup({
      // tslint:disable-next-line:max-line-length
      email: new FormControl('', Validators.compose([Validators.required, Validators.pattern(/^((([!#$%&'*+\-/=?^_`{|}~\w])|([!#$%&'*+\-/=?^_`{|}~\w][!#$%&'*+\-/=?^_`{|}~\.\w]{0,}[!#$%&'*+\-/=?^_`{|}~\w]))[@]\w+([-.]\w+)*\.\w+([-.]\w+)*)$/), Validators.pattern(/^\S*$/)])),
      password: new FormControl('', Validators.required),
    });
    this.loading = true;
    this.userService.reloadUser().then(res => {
      this.inventoryService.getPackagedata(this.eventName).subscribe(res => {
        this.team = res.teams;
        this.loading = false;
        // if already connected, error and redirect 
        if(this.didConnectAccount() == true){
          this.alertService.errorAlertWithResult(`You already connected a ${this.team.team_name_full} Team Account. Redirecting you to the account lookup page. `, 'Okay', '/new-group/choose-team');
        }
      }, err => {
        this.loading = false;
        this.alertService.errorAlertWithResult(err, 'Go Back', '/new-group');
      });
    })
  }

  didConnectAccount() {
    for(let i=0; i<this.userService.user.team_auths.length; i++){
      let thisAuth = this.userService.user.team_auths[i]
      if (thisAuth['team_id_fk'].toString() === this.team.team_id.toString()) {
        return true;
      }
    }
    return false; 
  }

  connectAccount() {
    this.markFormGroupTouch(this.connectForm);
    if (this.connectForm.valid) {
      this.app.toggleLoadingMsg('Connecting Team Account');
      this.onboardingService.connectTeamAccount(this.connectForm.value, this.team.team_id_fk).subscribe(res => {
        this.app.dismissLoading();
        this.userService.user.team_auths.push({ acct_id: res.tm_user.acct_id, team_id_fk: this.team.team_id_fk });
        this.router.navigate(['/new-group/choose-team/connect-account/upload-plan'], {
          queryParams: {
            acctId: res.tm_user.acct_id, teamId: this.team.team_id_fk
          }
        });
      }, err => {
        this.connectForm.reset();
        this.app.dismissLoading();
        this.alertService.errorAlert(err.error.message);
      });
    }
  }

  back() {
    this.router.navigate(['/new-group/choose-team']);
  }
  ngOnDestroy() {
    document.body.style.background = 'none';
  }

  private markFormGroupTouch(form: FormGroup) {
    (<any>Object).values(form.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouch(control);
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/reusable/connect-team-account/connect-team-account.component.ts